<template>
  <div id="app">
    <Navbar></Navbar>
    <router-view></router-view>
    <Footer></Footer>
  </div>
</template>

<script>
import Navbar from "./components/Navbar"
import Footer from "./components/Footer"

export default {
  name: 'app',
  components:{
    Navbar,
    Footer
  }
}
</script>

<style >
:root {
  --primaryColor: #00A492;
  --primaryLightColor: #008DA3;
  --primaryDarkColor: #0064A3;
  --secondaryColor: #2F395D;
  --primaryTextColor: #708482;
}
h1{
  font-weight: 500 !important;
}
h1{
  font-size: 34pt;
}
h2{
  font-size: 28pt;
}
h3{
  font-size: 20pt;
}
h4{
  font-size: 16pt;
}
p{
  font-size: 13pt;
}
</style>
